module.exports = __webpack_public_path__ + "static/media/ic_refresh.38d24d95.svg";